import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from '@chakra-ui/react';
import ModalHeaderAccent from '../../components/modal-header-accent';
import { translate } from '../../i18n';
import { TimeWindowForm } from './TimeWindowForm';

interface TimeWindowFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  groupId: string;
  /** Header text; defaults to the "add a slot" label used on the group card. */
  title?: string;
}

/**
 * The one modal that wraps `TimeWindowForm`, shared by the group card's
 * "add a slot" button and the post-create chain in `TimeWindowGroupList`
 * (MYS-70) so the two cannot drift.
 *
 * Deliberately a plain Chakra `Modal`, not `FormModal`: the form owns its
 * Save, and that Save must stay INSIDE the form. It replaces the group's whole
 * schedule, and `TimeWindowForm` withholds itself — Save included — whenever
 * the windows read did not answer (R127-1). A footer submit would render in
 * exactly that state. The footer therefore carries only the ghost cancel.
 */
export function TimeWindowFormModal({ isOpen, onClose, groupId, title }: TimeWindowFormModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" motionPreset="scale">
      <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(4px)" />
      <ModalContent maxW="900px" borderRadius="16px" overflow="hidden">
        <ModalHeaderAccent>{title ?? translate('time_windows.add_window')}</ModalHeaderAccent>
        <ModalCloseButton />
        <ModalBody pb={4}>
          <TimeWindowForm groupId={groupId} onSuccess={onClose} />
        </ModalBody>
        <ModalFooter pt={0} justifyContent="flex-start">
          <Button variant="ghost" h="44px" onClick={onClose}>
            {translate('cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
